module.exports = __webpack_public_path__ + "static/media/logo_web.19e936cc.png";